import React, { useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";

const SpecificationInputs = [
  {
    name: "productName",
    label: "Product Name",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "subproductName",
    label: "Subproduct Name",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "make",
    label: "Make",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "model",
    label: "Model",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "variant",
    label: "Variant",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "variantColor",
    label: "Variant Color",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "status",
    label: "Status",
    type: "multiselectdropdown",
    required: true,
    options: [
      { label: "Active", value: "Active" },
      { label: "Inactive", value: "Inactive" },
    ],
    gridClass: "col-lg-4",
  },
];

const AddSpecification = () => {
  const [formData, setFormData] = useState({});

  const navigate = useNavigate();
  const handleFormSubmit = (data) => {
    console.log("Form Data:", data);
  };

  return (
    <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate('/admin/manage-product/specification')}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add Specification</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Specification Details
        </span>
        <DynamicForm
          formConfig={SpecificationInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
        />
      </div>

      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            handleFormSubmit(formData);
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default AddSpecification;
